import { API_BASE } from '../../lib/apiOrigin';
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAdminLanguage } from "../../i18n/adminTranslations";
const client = axios.create();
const API = API_BASE;

export default function ContactMessagesTab({ token, onAuthFail }) {
  const { a } = useAdminLanguage();
  const [items, setItems] = useState([]), [busy, setBusy] = useState(false), [error, setError] = useState(""), [page, setPage] = useState(0), [refresh, setRefresh] = useState(0);
  const version = useRef(0), lock = useRef(false);
  const fail = (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) { setItems([]); onAuthFail?.(); }
    else setError("Unable to load or update messages. Try again.");
  };
  useEffect(() => {
    const current = ++version.current;
    setItems([]); setBusy(true); setError("");
    client.get(`${API}/admin/contact-messages?skip=${page * 50}&limit=50`, { headers: { "X-Admin-Token": token } })
      .then(({ data }) => { if (current === version.current) setItems(data); })
      .catch(err => { if (current === version.current) fail(err); })
      .finally(() => { if (current === version.current) setBusy(false); });
    return () => { version.current = current + 1; };
    // Reload for credentials, pagination or an explicit refresh, not parent renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, page, refresh]);
  async function update(item, status) {
    if (lock.current) return;
    lock.current = true; setBusy(true); setError("");
    const current = version.current;
    try {
      await client.patch(`${API}/admin/contact-messages/${encodeURIComponent(item.id)}`, { status }, { headers: { "X-Admin-Token": token } });
      if (current === version.current) setItems(old => old.map(row => row.id === item.id ? { ...row, status } : row));
    } catch (err) { if (current === version.current) fail(err); }
    finally { lock.current = false; if (current === version.current) setBusy(false); }
  }
  return <section data-testid="admin-contact-inbox" className="space-y-5">
    <div className="flex flex-wrap items-center justify-between gap-3"><h2 className="text-2xl font-bold">{a("Contact inbox")}</h2><button disabled={busy} onClick={() => setRefresh(n => n + 1)} className="min-h-[44px] rounded border p-3 focus:ring-2 focus:ring-sky-400 disabled:opacity-40">{a("Refresh")}</button></div>
    <p className="text-zinc-400">{a("Review contact messages here. Status changes only record manual follow-up; they do not send email or SMS or confirm a booking.")}</p>
    {error && <p role="alert" className="text-red-300">{a(error)}</p>}
    {busy && <p role="status">{a("Loading…")}</p>}
    {!busy && !error && !items.length && <p>{a("No contact messages on this page.")}</p>}
    {items.map(item => <article key={item.id} className="space-y-3 rounded border border-white/20 p-5 break-words">
      <h3 className="text-xl font-bold">{item.subject}</h3><p>{a("Name:")} {item.name}</p><p>{a("Phone:")} {item.phone}</p>
      <p className="whitespace-pre-wrap">{item.message}</p><p className="text-sm text-zinc-400">{item.created_at} · {(item.language || "en").toUpperCase()}</p>
      <p className="text-sm text-zinc-400">{a("Consent to store this message and respond by phone recorded.")}</p>
      <label>{a("Status")} <select aria-label={`${a("Status")}: ${item.name}`} disabled={busy} value={item.status} onChange={e => update(item, e.target.value)} className="ml-2 min-h-[44px] rounded border border-white/20 bg-zinc-900 p-2"><option value="new">{a("New")}</option><option value="contacted">{a("Contacted")}</option><option value="closed">{a("Closed")}</option></select></label>
    </article>)}
    <div className="flex flex-wrap items-center gap-4"><button disabled={busy || page === 0} onClick={() => setPage(p => p - 1)} className="min-h-[44px] rounded border p-3 disabled:opacity-40">{a("Previous")}</button><span>{a("Page")} {page + 1}</span><button disabled={busy || items.length < 50} onClick={() => setPage(p => p + 1)} className="min-h-[44px] rounded border p-3 disabled:opacity-40">{a("Next")}</button></div>
  </section>;
}
